function getStairCoreCost(state, props) {
	return state.stairCoreCount >= props.targetStairCoreCount ? 0 : 1e6;
}
export { getStairCoreCost };

//# sourceMappingURL=index152.js.map